import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { IndexLink, Link } from 'react-router';

class Order extends React.Component {
   render() {
      return (
         <div className="Order" >
            <Navbar className="Order_Nav" >
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/order/" activeStyle={{ color: 'red' }} >Order</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/order/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

Order.propTypes = {
   children: PropTypes.object
};

export default Order;



/** WEBPACK FOOTER **
 ** ./src/components/OrderManagement/Order.js
 **/